import DropdownItemGroup from './DropdownItemGroup';
import withItemSelectionManager from '../hoc/withItemSelectionManager';

export default withItemSelectionManager(DropdownItemGroup, 'radio');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/dropdown-menu/dist/esm/components/group/DropdownItemGroupRadio.js
// module id = 437
// module chunks = 0